function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.107 1.428a.75.75 0 01.75-.75h3.714a.75.75 0 01.75.75v3.714a.75.75 0 01-1.5 0V3.238L9.674 7.387a.75.75 0 01-1.06-1.06l4.148-4.149h-1.904a.75.75 0 01-.75-.75zm-2.72 8.245a.75.75 0 00-1.06-1.061L2.178 12.76v-1.903a.75.75 0 00-1.5 0v3.714a.748.748 0 00.76.75h3.705a.75.75 0 000-1.5H3.239l4.148-4.148z",
  fill: "currentColor"
})));